<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.student.courseEnrollment')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="card" v-if="step == '1'">

                    <div class="card-body">

                        <div class="form-group">
                            <label>{{$t('form.student.selectCourse')}}</label>
                            <v-select label="FullTitle"
                                :options="courses" v-model="course" :reduce="courses => courses"
                                :resetOnOptionsChange="true">
                            </v-select>
                        </div>

                        <b-button variant="primary" @click="getStudents()">{{$t('button.generateReport')}}</b-button>

                    </div>

                </div>

                <div class="card" v-if="step == '2'">
                    <div class="card-header bg-light">
                        <div class="text-right">
                            <button class="btn btn-primary btn-sm" @click="goBack()">
                                <i class="fas fa-arrow-left"></i> {{$t('button.goBack')}}</button>
                                <button class="btn btn-success btn-sm" @click="generate('classList')">
                                    <i class="fa fa-download" aria-hidden="true"></i> {{$t('button.classList')}}
                                </button>
                                <button class="btn btn-danger btn-sm" @click="generate('pdf')">
                                <i class="fa fa-download" aria-hidden="true"></i> {{$t('button.pdf')}}</button>
                                <button class="btn btn-success btn-sm" @click="generate('excel')">
                                    <i class="fa fa-download" aria-hidden="true"></i> {{$t('button.excel')}}
                                </button>
                        </div>
                    </div>

                    <div class="card-body table-responsive p-0">
                        <table class="table table-hover" v-if="students.length">
                            <thead>
                                <tr>
                                    <th>{{$t('form.student.courseCode')}}</th>
                                    <th>{{$t('form.student.courseTitle')}}</th>
                                    <th>{{$t('form.student.firstName')}}</th>
                                    <th>{{$t('form.student.lastName')}}</th>
                                    <th>{{$t('form.student.studentNumber')}}</th>
                                    <th>{{$t('form.student.email')}}</th>
                                    <th>{{$t('form.student.email2')}}</th>
                                    <th class="text-right">{{$t('form.student.booksIncl')}}</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="(student, index) in students" :key="index">
                                    <td>{{student.CourseCode}}</td>
                                    <td>{{student.CourseTitle}}</td>
                                    <td>{{student.FirstName}}</td>
                                    <td>{{student.LastName}}</td>
                                    <td>{{student.StudentNumber}}</td>
                                    <td>{{student.Email}}</td>
                                    <td>{{student.Email2}}</td>
                                    <td class="text-right">
                                        <input style="transform: scale(1.5);" v-model="student.BooksIncluded" type="checkbox" disabled>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p class="p-3 m-0" v-else>{{$t('noRecord')}}</p>
                    </div>
                    <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="5"
                        @paginate="paginate()">
                    </pagination>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import {
        required,
        minLength,
        maxLength,
        decimal,
        alpha
    } from "vuelidate/lib/validators";

    export default {
        props: ['permissions'],

        data() {
            return {
                isLoading: false,
                fullPage: true,

                alert: false,
                alertClass: '',
                alertMessage: '',

                step: 1,

                pagination: {
                    current_page: 1
                },

                course: null,

                courses: [],
                students: [],
            }
        },

        mounted() {
            if (!this.permissions.createStudentsEnrollment) {
                return this.$router.push('/');
            }

            this.getCourses();
        },

        methods: {

            async createToken(type) {
                let response = await axios.post('/api/api-tokens', {type});
                let token = '';

                if (response.status == 200) {
                    token = response.data.extra[0].token
                }

                return token;
            },

            /**
             * Export enrollment report - PDF | Excel
             */
            async generate(method) {
                let token = await this.createToken('enrollment-report');
                if (token == '') return;

                window.open(`/enrollment/${this.course.ID}/export?method=${method}&token=${token}`, "_blank");
            },

            goBack() {
                 this.step = 1;
                 this.students = [];
            },

            getStudents() {

                this.isLoading = true;

                if(!this.course) return;
                
                axios
                    .get(`/api/courses/${this.course.ID}/students`)
                    .then(response => {
                        this.isLoading = false;

                        this.students = response.data;

                        if(this.students) {
                            this.step = 2;
                        }
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error');
                    });
            },

             paginate() {
                this.getCourses();
            },

            getCourses() {
                axios
                    .get('/api/programs/online-mba-courses')
                    .then(response => {
                        this.isLoading = false;

                        this.courses = response.data;
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error');
                    });
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            }
        }
    }

</script>